import { noop } from 'lodash-es'
import { ISearchBoxProps } from 'office-ui-fabric-react'
import * as React from 'react'

export type SearchProps = ISearchBoxProps

interface State {
  active: boolean
  props?: SearchProps
}

const initialState: State = {
  active: false,
}

enum ActionType {
  REGISTER_SEARCH = 'REGISTER_SEARCH',
  UNREGISTER_SEARCH = 'UNREGISTER_SEARCH',
}

function reducer(
  state: State,
  {
    type,
    props,
  }: {
    type: ActionType
    props?: SearchProps
  }
): State {
  switch (type) {
    case ActionType.REGISTER_SEARCH:
      if (state.active) {
        throw new Error('Search already registered by other component.')
      }

      return {
        active: true,
        props,
      }
    case ActionType.UNREGISTER_SEARCH:
      return initialState
    default:
      return initialState
  }
}

export const SearchContext = React.createContext(
  {} as {
    state: State
    dispatch: any
  }
)

export function useSearchReducer() {
  return React.useReducer(reducer, initialState)
}

export function useSearchState() {
  const { state } = React.useContext(SearchContext)

  return state
}

export function useCustomSearch(props: SearchProps) {
  const { dispatch } = React.useContext(SearchContext)

  return React.useEffect(() => {
    if (dispatch) {
      dispatch({ type: ActionType.REGISTER_SEARCH, props })

      return () => dispatch({ type: ActionType.UNREGISTER_SEARCH })
    }
    return noop
    // eslint-disable-next-line
  }, [dispatch])
}

export function useSearch(userProps: Omit<SearchProps, 'onSearch' | 'value'>) {
  const [search, setSearch] = React.useState('')

  useCustomSearch({
    ...userProps,
    onSearch: setSearch,
    onClear: () => setSearch(''),
  })

  return search
}
